import Vue from 'vue';
import * as Lib from '@ext/index';
import moment from 'moment';
import { isString } from 'util';
import { ControladorDeRecuperacion } from '@/views/a-login/recuperar-controlador';

export class ControladorDeAutenticacion extends Vue
{

    public Recuperar: ControladorDeRecuperacion;

    public Tipo: 'ingreso' | 'recuperar' | 'inicio' = 'inicio';
    public Modo: 'email' | 'usuario' | 'password' = 'usuario';
    ModificarModo( modo: 'email' | 'usuario' | 'password' )
    {
        this.Modo = modo;
        this.$emit( 'modo' );
    }

    async ModificarTipo( tipo: 'ingreso' | 'recuperar' | 'inicio' )
    {
        this.Recuperar = null;
        if ( tipo == "ingreso" )
        {
            UsuarioActual.Iniciar();
        } else if ( tipo == 'recuperar' )
        {
            await this.IniciarRecuperacion();
        }

        this.Tipo = tipo;
        this.$emit( 'tipo' );
    }

    public async IniciarRecuperacion( tk?: string )
    {
        this.Recuperar = new ControladorDeRecuperacion();
        this.Recuperar.$on( 'ok', () => this.ModificarTipo( 'inicio' ) );
        await this.Recuperar.Iniciar( tk );
    }

    public async Iniciar()
    {
        try
        {
            let request = new Lib.apiRequest( '/s/u/sa/ss' );
            await request.get();
        } catch ( e )
        {
            Lib.Log( e );
        }
    }

    public async Validar(): Promise<boolean>
    {

        UsuarioActual.Iniciar();
        try
        {
            let request = new Lib.apiRequest( '/02868b813919' );
            if ( await request.post() )
            {
                let d = moment().getDay();
                if ( request.data && request.data[d] && request.data[d][7] && isString( request.data[d][7][4] ) )
                {

                    UsuarioActual.Nombre = request.data[d][7][4];
                    UsuarioActual.Apellido = request.data[d][7][5];
                    UsuarioActual.Usuario = request.data[d][7][6];
                    UsuarioActual.Email = request.data[d][7][7];
                    UsuarioActual.Grupo = request.data[d][7][8];
                    if ( request.data.avatar )
                        UsuarioActual.Avatar = request.data.avatar;
                    return true;
                }
            }
        } catch ( e )
        {
            Lib.Log( e );
        }
        return false;
    }

    public async CerrarSesion(): Promise<boolean>
    {

        UsuarioActual.Iniciar();
        try
        {
            let request = new Lib.apiRequest( '/02868b813912' );
            if ( await request.post() )
            {
                return true;
            }
        } catch ( e )
        {
            Lib.Log( e );
        }

        return false;
    }

    public async Comprobar( u: string ): Promise<{ resultado: boolean, mensaje?: string; }>
    {

        UsuarioActual.Iniciar();

        try
        {
            let request = new Lib.apiRequest( '/c' );
            request.body.u = u;
            if ( await request.post() )
            {
                if ( request.data.resultado )
                {
                    UsuarioActual.Iniciar( request.data.usuario );
                    this.ModificarModo( 'password' );
                }
                return request.data;
            }

        } catch ( e )
        {
            //Lib.Log( e );
        }
        return { resultado: false, mensaje: 'El servicio no está disponible. Intentá en unos segundos.' };
    }

    public Redireccionar: string = '';
    public async Autenticar( p: string ): Promise<{ resultado: boolean, mensaje?: string; }>
    {

        try
        {
            let request = new Lib.apiRequest( '/s' );
            //const sha1 = require( 'js-sha1' );
            //request.body.p = sha1( p ) + '95a02873d057b02d352cbc02868b8139192199b8';
            request.body.p = p;

            if ( await request.post() )
            {
                return request.data;
            }

        } catch ( e )
        {
            Lib.Log( e );
        }
        return { resultado: false, mensaje: 'El servicio no está disponible. Intentá en unos segundos.' };

    }

}


export class Usuario
{

    public Nombre: string = "";
    public Apellido: string = "";
    public Usuario: string = "";
    public Avatar: string = "";
    public Grupo: string = "";
    public get Iniciales(): string
    {
        let ini = "";

        if ( this.Apellido && this.Nombre )
        {
            ini += this.Nombre.substring( 0, 1 );
            ini += this.Apellido.substring( 0, 1 );
        } else if ( this.Nombre )
        {
            ini = this.Nombre.substring( 0, 2 );
        }
        else if ( this.Usuario )
        {
            ini = this.Usuario.substring( 0, 2 );
        }

        return ini.toUpperCase();

    }
    public Email: string = "";

    public Existe: boolean = false;

    public Iniciar(js?: any)
    {

        if ( js )
        {
            this.Nombre = js.nombre;
            this.Apellido = js.apellido;
            this.Usuario = js.usuario;
            this.Avatar = js.avatar;
            this.Email = js.email;
            this.Grupo= js.grupo;

            this.Existe = true;
        } else
        {
            this.Nombre = "";
            this.Apellido = "";
            this.Usuario = "";
            this.Avatar = "";
            this.Email = "";
            this.Grupo = "";

            this.Existe = false;
        }

    }

}

const UsuarioActual = new Usuario();
const Controlador = new ControladorDeAutenticacion();
export { Controlador, UsuarioActual };